import sdl from '@jds/react-generated-sdl/JDSMenuBlockItem';
import type { JDSMenuBlockItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSMenuBlockItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    type = 'entry',
    selected = false,
    disabled = false,
    hasIcon = false,
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { type, selected, disabled, hasIcon, ariaLabel, ...rest },
    'JDSMenuBlockItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MenuBlockItem = withLogic(
  Component
) as React.FC<JDSMenuBlockItemProps> & { slotName?: string };

MenuBlockItem.displayName = 'MenuBlockItem';
MenuBlockItem.slotName = 'jds_menu_block_item';

export { MenuBlockItem, type JDSMenuBlockItemProps };
